module.exports = __webpack_public_path__ + "static/19-8d943ed6d6ad2bc9b91e8b673eb63ca4.mp4";